import { ceil } from 'lodash-es'
import { createContext, FC, PropsWithChildren, useContext, useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'

export type PaginatorState = {
  page: number
  total: number
  size?: number | null
}

export type PaginatorContextProps = {
  paginator: PaginatorState
}

type PaginatorDetails = PaginatorState & {
  pageStartItemNumber: number
  totalPages: number
  isFirst: boolean
  isLast: boolean
  pageEndItemNumber: number
}

export type PaginatorStore = PaginatorDetails & {
  next: () => void
  previous: () => void
  setTotal: (total: number) => void
  setPageSize: (size: number) => void
  setPage: (page: number) => void
}

// @ts-expect-error TS(2345) FIXME: Argument of type 'undefined' is not assignable to ... Remove this comment to see the full error message
const PaginatorContext = createContext<PaginatorStore>(undefined)

export const getPaginatorDetails = (paginatorState: PaginatorState): PaginatorDetails => {
  const { page: defaultPage, total, size = 10 } = paginatorState
  // @ts-expect-error TS(2531) FIXME: Object is possibly 'null'.
  const totalPages = total < size ? 1 : ceil(total / size)
  const lastPage = totalPages - 1
  const page = defaultPage < 0 ? 0 : defaultPage
  // @ts-expect-error TS(2531) FIXME: Object is possibly 'null'.
  const pageStartItemNumber = page * size + 1
  const isFirst = page === 0 || total === 0
  const isLast = page === lastPage

  return {
    page,
    total,
    size,
    pageStartItemNumber,
    totalPages,
    isFirst,
    isLast,
    // @ts-expect-error TS(2531) FIXME: Object is possibly 'null'.
    pageEndItemNumber: isLast ? total : (page + 1) * size,
  }
}

export const usePaginator = (): PaginatorStore => {
  const paginationStore = useContext(PaginatorContext)
  if (!paginationStore) {
    throw new Error('Must use usePaginator within a PaginatorContext')
  }

  return paginationStore
}

export enum PaginationKeys {
  PAGE = 'page',
  SIZE = 'size',
}

const defaultValues: PaginatorState = {
  page: 0,
  total: 0,
  size: 10,
}

export const usePurePaginator = (initialValues?: Partial<PaginatorState>): PaginatorStore => {
  const [page, setPage] = useState(initialValues?.page ?? defaultValues.page)
  const [total, setTotal] = useState(initialValues?.total ?? defaultValues.total)
  const [size, setPageSize] = useState(initialValues?.size ?? defaultValues.size)
  const paginatorDetails = getPaginatorDetails({ page, total, size })

  return {
    ...paginatorDetails,
    next: () => !paginatorDetails.isLast && setPage(page + 1),
    previous: () => !paginatorDetails.isFirst && setPage(page - 1),
    setTotal,
    setPageSize,
    setPage,
  }
}

export const PaginatorContextProvider: FC<PropsWithChildren<PaginatorContextProps>> = ({ children, paginator }) => {
  const paginationStore = usePurePaginator(paginator)
  const history = useHistory()

  const setPageUrlParams = (newPage: number, newSize: number) => {
    const urlParams = new URLSearchParams(history.location.search)
    urlParams.set(PaginationKeys.PAGE, String(newPage))
    urlParams.set(PaginationKeys.SIZE, String(newSize))
    const newQuery = urlParams.toString()

    if (history.location.search !== `?${newQuery}`) {
      history.replace(`?${newQuery}`)
    }
  }

  // Updated url if page is modified by getPaginatorDetails
  if (paginationStore.page !== paginator.page) {
    // @ts-expect-error TS(2345) FIXME: Argument of type 'number | null | undefined' is no... Remove this comment to see the full error message
    setPageUrlParams(paginationStore.page, paginationStore.size)
  }

  useEffect(
    // @ts-expect-error TS(2345) FIXME: Argument of type 'number | null | undefined' is no... Remove this comment to see the full error message
    () => setPageUrlParams(paginationStore.page, paginationStore.size),
    [paginationStore.page, paginationStore.size]
  )

  return <PaginatorContext.Provider value={paginationStore}>{children}</PaginatorContext.Provider>
}
